// Лёгкий трекинг активности: отправляет события в backend /api/events.
// Намеренно НЕ зависит от lib/api и lib/telegram, чтобы не было циклических
// импортов (openLink в telegram.ts тоже шлёт событие).

import type { MiniAppEventType } from "@anton/shared";

const BASE_URL = import.meta.env.VITE_BACKEND_URL ?? "";

function getInitDataRaw(): string {
  const wa = (window as any).Telegram?.WebApp;
  // В dev backend принимает "dev" как mock-идентификацию
  return wa?.initData || "dev";
}

// Fire-and-forget: трекинг не должен ломать UX, любые ошибки глотаем.
export function trackEvent(type: MiniAppEventType, label?: string, meta?: Record<string, unknown>): void {
  try {
    fetch(`${BASE_URL}/api/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ initData: getInitDataRaw(), type, label, meta }),
      keepalive: true, // долетит даже если страница уже уходит
    }).catch(() => {});
  } catch {
    /* noop */
  }
}
